// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
// Copyright (C) 2024 TU Wien.
//
// InvenioRDM TUW is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import { RecordsResultsListItemNoStats } from "../../components/overrides/RecordsResultsListItemNoStats";
import { TimelineFeedHeader } from "../requests/timeline/overrides/TimelineFeedHeader";
import { curationComponentOverrides } from "@js/invenio_curations/requests";
import { DepositBox } from "@js/invenio_curations/deposit/DepositBox";
import { RequestMetadata } from "@js/invenio_theme_tuw/RequestMetadata";

export const overriddenComponents = {
  "InvenioAppRdm.Search.ResultsList.container": RecordsResultsListItemNoStats,
  "InvenioCommunities.DetailsSearch.ResultsList.container": RecordsResultsListItemNoStats,
  // Guest Access Request customisation
  "TimelineFeed.header": TimelineFeedHeader,

  "InvenioRequest.RequestMetadata.Layout": RequestMetadata,
  "InvenioAppRdm.Deposit.CardDepositStatusBox.container": DepositBox,
  ...curationComponentOverrides,
};
